import { client } from '../client';
import { UserProfile } from './types/UserProfile';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const verifyEmailAddress = async (code: string, userRole?: string): Promise<UserProfile> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.post(`${prefix}/users/verify_email`, {
    code,
  });

  return data;
};
